import React from 'react';
import { PII_DECLARATIONS, PII_STATUSES, PII_URL } from '../Constants';
import './PiiDeclaration.scss';

// Must match the current version in PII_DECLARATION_VERSIONS (server/Constants.js), since the server stamps
// that version on every declaration. Changing this wording needs a new server version in the same deploy.
const PII_DECLARATION_QUESTION = 'Do you currently hold appropriate Professional Indemnity Insurance (PII) covering your practice as an optometrist in Australia?';

/**
 * Maps the server's effective PII status to the answer to pre-select ('YES', 'NO' or null when unanswered).
 * @param {string} piiStatus - profile.piiStatus
 */
export const getPiiDeclarationFromStatus = (piiStatus) => {
  if (piiStatus === PII_STATUSES.SELF_DECLARED.key || piiStatus === PII_STATUSES.VERIFIED.key) {
    return PII_DECLARATIONS.YES;
  }
  if (piiStatus === PII_STATUSES.DECLARED_NONE.key) {
    return PII_DECLARATIONS.NO;
  }
  return null;
};

/**
 * Yes/No PII declaration, used in onboarding, the credentials prompts and the PII modal.
 * Yes/No are radios styled as pills.
 * @param {string|null} value - 'YES', 'NO' or null
 * @param {Function} onChange - called with 'YES' or 'NO'
 * @param {string} name - radio group name; must be unique on the page
 * @param {string} [title] - optional heading above the question (onboarding styles it like the ABN/AHPRA labels)
 * @param {boolean} [showHelp] - show the Optometry Board link; onboarding turns it off and lists the link up top
 */
const PiiDeclaration = ({ value, onChange, name, disabled = false, title = null, showHelp = true }) => {
  const options = [
    { answer: PII_DECLARATIONS.YES, text: 'Yes' },
    { answer: PII_DECLARATIONS.NO, text: 'No' },
  ];
  return (
    <fieldset className={'pii-declaration'} disabled={disabled}>
      <legend className={'pii-question'}>
        {title && <span className={'pii-title'}>{title}</span>}
        {PII_DECLARATION_QUESTION}
      </legend>
      <div className={'pii-options'}>
        {options.map(({ answer, text }) => (
          <label className={`pii-option ${value === answer ? 'selected' : ''}`} key={answer}>
            <input type={'radio'} name={name} checked={value === answer} onChange={() => onChange(answer)} />
            <span>{text}</span>
          </label>
        ))}
      </div>
      {showHelp &&
        <p className={'pii-help'}>
          {'Visit the '}
          <a href={PII_URL} target={'_blank'} rel={'noreferrer'}>{'Optometry Board of Australia website'}</a>
          {' to check the PII requirements, if necessary.'}
        </p>
      }
      {value === PII_DECLARATIONS.NO && <span className={'pii-required'}>{'Professional Indemnity Insurance is required to register with Locumly.'}</span>}
    </fieldset>
  );
};

export default PiiDeclaration;
